<template>
  <div class="animated fadeIn">
    <b-modal @close="hideModal" @hide="hideModal" ref="modal-serasa-followup" scrollable centered>
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Selecione o Follow Up da Consulta Serasa
      </template>
      <div class="col-md-12">
        <label for="txtGroup">
          <small v-if="form.eventoId.required" class="text-danger">*</small>
          Follow-up Padrão:
        </label>
        <div class="input-group">
          <b-form-select v-model="form.eventoId.value" :options="form.eventoId.options" :state="form.eventoId.state" class="mb-3">
            <template slot="first">
              <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
            </template>
          </b-form-select>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <b-button
            class="btn btn-sm btn-success rounded-4 ml-2"
            size="sm"
            @click.prevent="onSave"
          >
            <i class="fas fa-check-circle"></i><span class="d-md-down-none">&nbsp; Confirmar</span>
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>

import EventRepository from '@/shared/http/repositories/configurations/event.js'
import serasaFollowUpForm from '@/views/private/crm/board/modal/serasa/serasaFollowUp-form.js'

import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import SerasaRepository from '@/shared/http/repositories/configurations/serasa'

const serasaFollowUpData = {
  eventoId: null
}

export default {
  name: 'SerasaFollowUp',
  mixins: [ActionsForm],
  props: {
    evento: {
      type: Function,
      default: null
    },
    attributes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: serasaFollowUpForm,
      data: serasaFollowUpData,
      boardColumn: null,
      index: null
    }
  },
  created () {
    this.loadData(this.attributes[0], this.attributes[1])
  },
  mounted () {
    this.$refs['modal-serasa-followup'].show()
  },
  methods: {
    async loadData (index, column) {
      this.boardColumn = column
      this.index = index
      this.onLoadAllEventType()
      try {
        const response = await SerasaRepository.GetParams()
        if (response.status === 200) {
          this.onEdit(response.data)
          this.form.eventoId.value = response.data.eventoEntity ? response.data.eventoEntity.id : null
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    hideModal (submited) {
      let success = submited === true
      this.$emit('closeModal', success, this.index)
    },
    abort () {
      this.$emit('Abort')
    },
    onSave () {
      this.boardColumn.eventoId = this.form.eventoId.value
      this.$parent.boardColumns[this.index] = this.boardColumn
      this.hideModal(true)
    },
    onLoadAllEventType () {
      loading.push()
      this.form.eventoId.options = []
      EventRepository.GetAllActive(null, this.isVisita)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.events = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.events.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic
                  })
                }
              })

              this.events.sort((a, b) => {
                let typeA = a.tipo.toLowerCase()
                let typeB = b.tipo.toLowerCase()
                if (typeA < typeB) {
                  return -1
                }
                if (typeA > typeB) {
                  return 1
                }
                return 0
              })

              let opt = []
              this.events.forEach(x => {
                if (!opt.find(opt => opt.label === x.tipo)) {
                  let options = []
                  this.events.forEach(y => {
                    if (y.tipo === x.tipo) {
                      options.push({ value: y.id, text: y.nome, mnemonic: y.mnemonic })
                    }
                  })
                  opt.push({
                    label: x.tipo,
                    options: options
                  })
                  options = []
                }
              })
              this.form.eventoId.options = opt
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
        .finally(() => {
          loading.pop()
        })
    }
  }
}

</script>
<style lang="scss">
.warn{
  &__tittle{
    color: #F00;
    font-size: 1rem;
    font-weight: 600;
  }
  &__subtitle{
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
  hr{
    margin: 1.25rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/serasa/serasaFollowUp.vue